/* eslint-disable no-unused-vars */
import { useState } from "react";

// LQC-2676 - a plain decimal entry, for a strike and for the swap ticket's coupon and
// spread. Deliberately NOT NominalInput: the M / MM shorthand belongs to face values,
// and "98.5m" as a strike would be a typo, not 98,500.

interface ITicketNumberInput {
  value: number | null;
  onCommit: (value: number | null) => void;
  testId: string;
  placeholder?: string;
}

// Allows a half-typed value ("98." or a lone "-"), so validation runs again on commit.
export function isValidNumberInput(value: string): boolean {
  return /^-?\d*\.?\d*$/.test(value);
}

export function returnCommittedNumber(value: string): number | null {
  const trimmed = value.trim();
  if (trimmed === "") return null;
  const parsed = Number(trimmed);
  return isNaN(parsed) ? null : parsed;
}

const TicketNumberInput = ({
  value,
  onCommit,
  testId,
  placeholder = "e.g. 98.5",
}: ITicketNumberInput) => {
  const [isEditing, setIsEditing] = useState(false);
  const [localValue, setLocalValue] = useState("");

  const displayValue = isEditing
    ? localValue
    : value !== null
      ? String(value)
      : "";

  return (
    <div className="flex h-[28px] w-full items-center rounded-md border border-gray-300 dark:border-gray-600 dark:bg-gray-800">
      <input
        data-testid={testId}
        id={testId}
        type="text"
        inputMode="decimal"
        placeholder={placeholder}
        className="h-full w-full bg-transparent px-2 text-xs outline-none dark:text-gray-200"
        value={displayValue}
        onFocus={() => {
          setLocalValue(value !== null ? String(value) : "");
          setIsEditing(true);
        }}
        onChange={(e) => {
          if (isValidNumberInput(e.target.value)) setLocalValue(e.target.value);
        }}
        onBlur={() => {
          setIsEditing(false);
          onCommit(returnCommittedNumber(localValue));
        }}
        onKeyDown={(e) => {
          if (e.key === "Enter") e.currentTarget.blur();
        }}
      />
    </div>
  );
};

export default TicketNumberInput;
